










































import { ClientRoutes } from "@/data/enums/router";
import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
  components: {
    "client-login-form": () =>
      import("@/components/app/client/clientLoginForm.vue")
  },
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect",
      hasRegistrationEnabled: "brand/hasRegistrationEnabled",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient"
    })
  }
})
export default class Login extends Vue {
  public readonly currentOauthClient!: string;
  public readonly defaultOauthClient!: string;
  public readonly isSupportedOauthClient!: boolean;
  public readonly defaultOauthClientRedirect!: string;
  public readonly hasRegistrationEnabled!: boolean;
  public readonly clientRegisterRoute = { name: ClientRoutes.REGISTER };
}
